import React from 'react';

import BillingDetailsPageContent
  from 'components/dashboard/billing-content/BillingDetailsPageContent';

const BillingDetailsPage = () => <BillingDetailsPageContent />;

export default BillingDetailsPage;
